import React, { useEffect, useState, useCallback } from "react";
import { Typography, Button, Chip, TextField } from "@material-ui/core";
import { toast } from "react-toastify";
import api from "../../services/api";
import toastError from "../../errors/toastError";

// feat_416 (CK23) — superadmin › empresa › Automatización:
// "Mensaje de bienvenida una sola vez". Muestra si el ajuste está prendido y
// cuántos contactos ya lo recibieron, y permite limpiar el flag de TODOS los
// contactos de la empresa (acción auditada en SystemLog). Para confirmar hay
// que escribir RESETEAR. Textos en español, como el resto del panel superadmin.
// Si el backend todavía no tiene el endpoint (404) la tarjeta no se muestra.

const WelcomeNoticeSuperCard = ({ companyId }) => {
  const [status, setStatus] = useState(null);
  const [confirmText, setConfirmText] = useState("");
  const [busy, setBusy] = useState(false);

  const load = useCallback(async () => {
    if (!companyId) return;
    try {
      const { data } = await api.get(`/superadmin/companies/${companyId}/welcome-notice`);
      setStatus(data);
    } catch (err) {
      setStatus(null);
    }
  }, [companyId]);

  useEffect(() => {
    load();
  }, [load]);

  if (!status) return null;

  const handleReset = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/superadmin/companies/${companyId}/welcome-notice/reset`, { confirm: true });
      toast.success(`Listo: ${data.reset} contactos van a volver a recibir el mensaje de bienvenida.`);
      setConfirmText("");
      await load();
    } catch (err) {
      toastError(err);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={{ marginTop: 16 }}>
      <Typography variant="subtitle2" style={{ fontWeight: 700, marginBottom: 4 }}>
        Mensaje de bienvenida una sola vez
      </Typography>
      <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", marginBottom: 6 }}>
        <Chip
          size="small"
          label={status.enabled ? "Ajuste prendido" : "Ajuste apagado"}
          style={status.enabled ? { background: "#d9fdd3", color: "#075e54" } : undefined}
        />
        <Typography variant="body2">
          {status.marked} contacto{status.marked === 1 ? "" : "s"} ya lo recibieron
        </Typography>
      </div>
      <Typography variant="caption" color="textSecondary" display="block" style={{ marginBottom: 8 }}>
        El ajuste lo prende el admin de la empresa en Ajustes › Automatizaciones. Limpiar en bloque hace que
        TODOS los contactos vuelvan a recibir el mensaje en su próximo saludo. Queda registrado en los logs.
      </Typography>
      <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
        <TextField
          size="small"
          variant="outlined"
          label='Escribí "RESETEAR"'
          InputLabelProps={{ shrink: true }}
          value={confirmText}
          onChange={e => setConfirmText(e.target.value)}
          disabled={!status.marked}
        />
        <Button
          variant="outlined"
          color="secondary"
          size="small"
          disabled={busy || !status.marked || confirmText.trim() !== "RESETEAR"}
          onClick={handleReset}
        >
          Limpiar en todos los contactos
        </Button>
      </div>
    </div>
  );
};

export default WelcomeNoticeSuperCard;
